import { isCreditPurchaseProduct } from '@vy/services';
import type { FixedProductInput } from '@vy/types';
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { PlanInputForm } from '../create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';

export type CreditPurchaseFromProduct = {
  product: FixedProductInput;
  originalIndex: number;
};

export function usePartitionedFixedProducts(): {
  serviceFees: FixedProductInput[];
  creditPurchasesFromProducts: CreditPurchaseFromProduct[];
} {
  const { control } = useFormContext<PlanInputForm>();
  const fixedProducts = useWatch({ control, name: 'fixedProducts' }) ?? [];

  return useMemo(
    () => ({
      serviceFees: fixedProducts.filter((p) => !isCreditPurchaseProduct(p)),
      creditPurchasesFromProducts: fixedProducts.flatMap<CreditPurchaseFromProduct>((product, index) =>
        isCreditPurchaseProduct(product) ? [{ product, originalIndex: index }] : [],
      ),
    }),
    [fixedProducts],
  );
}
